/**
 * PURPOSE: Header mínimo/mobile para árbitros en HAYLLIS.
 * ROUTE: src/pages/VolleyballViewer/components/ViewerHeader.jsx
 */

import { FaCompress, FaExpand, FaRightFromBracket, FaRotate } from "react-icons/fa6";
import ViewerConnectionBadge from "./ViewerConnectionBadge.jsx";

function IconButton({ title, onClick, children, danger = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "grid h-8 w-8 shrink-0 place-items-center rounded-xl border bg-white shadow-sm transition active:scale-95",
        danger ? "border-rose-200 text-rose-600" : "border-slate-200 text-slate-700",
      ].join(" ")}
      title={title}
      aria-label={title}
    >
      {children}
    </button>
  );
}

export default function ViewerHeader({ connectionState, isFullscreen, onToggleFullscreen, onResync, onLogout }) {
  return (
    <header className="shrink-0 border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex h-12 max-w-5xl items-center justify-between gap-2 px-2.5">
        <div className="min-w-0">
          <div className="truncate text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">HAYLLIS</div>
          <div className="truncate text-sm font-black leading-none text-slate-950">Volleyball</div>
        </div>

        <div className="flex shrink-0 items-center gap-1.5">
          <ViewerConnectionBadge state={connectionState} />
          <IconButton title="Re-sincronizar" onClick={onResync}>
            <FaRotate className="h-3.5 w-3.5" />
          </IconButton>
          <IconButton title="Pantalla completa" onClick={onToggleFullscreen}>
            {isFullscreen ? <FaCompress className="h-3.5 w-3.5" /> : <FaExpand className="h-3.5 w-3.5" />}
          </IconButton>
          <IconButton title="Salir" onClick={onLogout} danger>
            <FaRightFromBracket className="h-3.5 w-3.5" />
          </IconButton>
        </div>
      </div>
    </header>
  );
}
